import { useSelectedTags } from "@/components/mapping/hooks";
import { factAddress } from "@/jspreadsheet/utils";
import { useMappingStore } from "@/stores/mapping";

export const usePreviewChangeTooltip = () => {
  const selectedFact = useMappingStore((state) => state.fact.selected);
  const addressWithSheetId = selectedFact ? factAddress(selectedFact) : null;
  const { selectedMappedInfo } = useSelectedTags(addressWithSheetId);

  const isFullTagged =
    selectedMappedInfo.tags?.some((tag) => tag.type === "MEMBER") &&
    selectedMappedInfo.tags?.some((tag) => tag.type === "LINE_ITEM");

  return {
    isFullTagged,
  };
};
